import React from "react";
import { Skeleton } from "@mui/material";

const SkeletonLoading = ({ height }) => {
  return (
    <>
      <Skeleton
        variant="rounded"
        width="100%"
        height={height}
        sx={{ marginY: "10px" }}
      />
    </>
  );
};

export default SkeletonLoading;
